import { SelectionItem } from "../selection-item";
import { SelectionEvent } from "../SelectionEvent";
import { SelectionEventType } from "../SelectionEventType";

export class SelectionStrategySelectAll {

    static syncSelectionItems(values: any[], selectionItems: SelectionItem[], compare: (a, b) => boolean, preSelected = false): boolean {
        {
            let selectionFound = false;
            selectionItems.forEach(si => {
                if (values.some(v => compare(v, si.value) || (preSelected))) {
                    si.selected = true;
                    selectionFound = true;
                } else {
                    si.selected = false;
                    si.partialSelected = false;
                }
                if (si.children) {
                    const result = this.syncSelectionItems(values, si.children, compare, si.selected);
                    if (!si.selected && result) {
                        si.selected = false;
                        si.partialSelected = true;
                        selectionFound = true;
                    }
                }
            });
            return selectionFound;
        }
    }

    static handleParents(item: SelectionItem) {
        const total = this.getTreeCount(item.children);
        const selected = this.getSelectedItems(item.children).length;
        if (total === selected) {
            item.selected = true;
        } else if (selected > 0) {
            item.selected = false;
            item.partialSelected = true;
        } else {
            item.selected = false;
            item.partialSelected = false;
        }
    }

    static toggleTree(items: SelectionItem[], value: boolean): SelectionEvent[] {
        const events = [];
        items.forEach(i => {
            if (i.selected !== value) {
                events.push(new SelectionEvent(value ? SelectionEventType.Checked : SelectionEventType.Unchecked, i.value));
            }

            i.selected = value;
            if (!value) {
                i.partialSelected = false;
            }

            if (i.children) {
                events.push(...this.toggleTree(i.children, value));
            }
        });

        return events;
    }

    private static getSelectedItems(selectionItems: SelectionItem[]): SelectionItem[] {
        const result = [];
        result.push(...selectionItems.filter(si => si.selected));
        result.push(...selectionItems.filter(si => si.children).map(si => this.getSelectedItems(si.children)).reduce((a, b) => a.concat(b), []));

        return result;
    }

    private static getTreeCount(items: SelectionItem[]): number {
        return items.length + items.filter(si => si.children).map(si => this.getTreeCount(si.children)).reduce((a, b) => a + b, 0);
    }
}
